module.exports = __webpack_public_path__ + "static/media/fileupload.f6fa31a5.svg";